<template>
  <div class="berita-by-detail text-left bg-slate-50 mt-4 px-4 md:px-[15vw]">
    <div class="container mx-auto">
      <div class="bread-crumb md:text-xl text-sm">
        <router-link to="/">Home</router-link>
        <span class="mx-2">/</span>
        <router-link
          :to="{ name: 'BeritaByCategory', params: { slug_cat: beritaDetail?.slug_cat } }"
          class="text-emerald-700 hover:underline"
        >
          {{ beritaDetail?.kategori || 'Kategori tidak ditemukan' }}
        </router-link>
        <span class="mx-2">/</span>
        <span class="text-emerald-700 font-bold">
          {{ beritaDetail?.judul || 'Judul tidak ditemukan' }}
        </span>
      </div>

      <div class="title-detail md:my-[5vh]">
        <div class="title"></div>
      </div>

      <div class="warp-content">
        <div class="grid grid-cols-12 gap-8 my-4">
          <div class="col-span-12 md:col-span-8">
            <div class="card-detail-berita border-b border-gray-500 pb-[3vh]">
              <div
                class="title-detail text-xl md:text-3xl font-bold text-emerald-700 leading-relaxed"
              >
                {{ beritaDetail?.excerpt || 'Judul tidak ditemukan' }}
              </div>
              <div
                class="info-detail flex gap-7 my-6 md:my-4 text-sm md:text-lg"
              >
                <div class="diterbitkan">
                  <i class="fa fa-clock"></i>
                  <span class="text-neutral-400 ms-2"
                    >Diterbitkan pada: {{ beritaDetail?.tanggal || 'Tanggal tidak tersedia' }}</span
                  >
                </div>
                <div class="ditulis">
                  <i class="fa fa-user"></i>
                  <span class="text-neutral-400 ms-2"
                    >Penulis: {{ beritaDetail?.penulis || 'Penulis tidak diketahui' }}</span
                  >
                </div>
              </div>
              <div class="image-berita">
                <img
                  :src="beritaDetail?.gambar || ''"
                  class="w-full h-auto"
                  alt="Gambar Berita"
                />
              </div>
              <div class="isi-berita mt-5 text-lg leading-relaxed">
                {{ beritaDetail?.isi || 'Konten berita tidak ditemukan.' }}
              </div>
            </div>
            <div class="bottom-berita my-10">
              <TitleSection title="Berita Terkait" class="mb-4" />
              <div
                class="card-very-new-berita mt-2 mb-1 md:mt-4 md:mb-2 cursor-pointer"
                v-for="(berita, index) in latestBerita"
                :key="index"
                @click="navigateToDetail(berita)"
              >
                <div
                  class="text-very-new-berita text-lg md:text-3xl font-medium line-clamp-3 leading-7 text-emerald-700 hover:text-emerald-900 cursor-pointer"
                >
                  {{ berita.judul }}
                </div>
                <hr
                  class="my-4 border-t border-gray-300"
                  v-if="index < latestBerita.length - 1"
                />
              </div>
            </div>
          </div>

          <div class="md:col-span-4 hidden md:block">
            <MiniTitle title="Berita Terbaru" />
            <div
              class="card-very-new-berita mt-4 mb-2 cursor-pointer"
              v-for="(berita, index) in latestBerita"
              :key="index"
              @click="navigateToDetail(berita)"
            >
              <div
                class="text-very-new-berita text-sm md:text-xl font-bold line-clamp-3 leading-7 text-emerald-700 hover:text-emerald-900 cursor-pointer"
              >
                {{ berita.judul }}
              </div>
              <hr
                class="my-4 border-t border-gray-300"
                v-if="index < latestBerita.length - 1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useBeritaStore } from "@/store/beritaStore";

import MiniTitle from "@/components/MiniTitle.vue";
import TitleSection from "@/components/TitleSection.vue";

const route = useRoute();
const router = useRouter();
const beritaStore = useBeritaStore();

const beritaDetail = computed(() => {
  const slugBerita = route.params.slug_berita;
  return beritaStore.berita.find((berita) => berita.slug_berita === slugBerita);
});

const latestBerita = computed(() => {
  return beritaStore.berita
    .slice()
    .sort((a, b) => new Date(b.created_time) - new Date(a.created_time))
    .slice(0, 4);
});

const navigateToDetail = (berita) => {
  router.push({
    name: 'DetailBerita',
    params: { slug_cat: berita.slug_cat, slug_berita: berita.slug_berita },
  });
};
</script>

<style scoped></style>
